import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  offset: theme.mixins.toolbar,
  bar: {
    backgroundColor: '#B22222',
  },
}))
